import { render, staticRenderFns } from "./followList.vue?vue&type=template&id=3534beb4"
import script from "./followList.vue?vue&type=script&lang=js"
export * from "./followList.vue?vue&type=script&lang=js"
import style0 from "./followList.vue?vue&type=style&index=0&id=3534beb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports